import React, { useState } from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Button, CircularProgress, Grid} from '@material-ui/core';
import {DashboardStyles} from '../../../styles/dashboard';
import { useHistory } from 'react-router-dom';
import {connect} from 'react-redux';
import * as actions from "../../../store/actions";
import {DateFormatter} from "../../../shared/formatter";
import Select from "@material-ui/core/Select";
import {inputChangedHandler} from "../../../shared/utility";
import MenuItem from "@material-ui/core/MenuItem";
import { canUserChangeAppointment } from '../../../shared/vehicle';

const useStyles = makeStyles((theme) => {
    return {
        ...DashboardStyles(theme),
        label: {
            color: 'white',
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "18px",
            lineHeight: "20px",
            display: "flex",
            alignItems: "flex-end",
            paddingBottom: "4px"
        },
        formElement: {
            paddingBottom: "8px",
            '& .MuiFormHelperText-contained': {
                marginLeft: "0px",
            },
        },
        input: {
            backgroundColor: "transparent",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "16px",
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            color: 'white'
        },
        map: {
            filter: "invert(95%)",
            border: "none"
        }
   }
});

let formData = {
    controls: {
        actionField : {
            key: 'actionField',
            label: 'Action',
            value: '',
            values: [
                {key: 'reschedule', value: "Reschedule Appointment"},
                {key: 'cancel', value: "Cancel Appointment"}
            ],
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
            helperText: null,
            type: "dropdown"
        }
    },
    loading: false,
    valid: false,
    touched: false,
    generalError: null,
    currentPage: 'details'
};

const AppointmentDetails = (props) => {

    const classes = useStyles();
    const history = useHistory();
    const [formState, setFormState] = useState(formData);

    const selectedAppointmentId = props.match && props.match.params ? +props.match.params['id'] : null;
    const selectedAppointment = props.selectedVehicle && props.selectedVehicle.appointments ?
        props.selectedVehicle.appointments.find((appointment) => +(appointment.id) === selectedAppointmentId) : null;

    const location = props.selectedVehicle && props.selectedVehicle.matchingClients ?
        props.selectedVehicle.matchingClients.find((location) => +(location.locationId) === selectedAppointment.locationId) : null;

    const actionField = formState.controls.actionField;

    const handleSubmit = () => {
        props.dispatch(actions.changeAppointment(selectedAppointment.id, actionField.value, (err, data) => {
            if (err) {
                return;
            }
            setFormState({
                ...formState,
                currentPage: 'submitted'
            });
        }));
    }
    const appointmentDetails = (
        <Box>
            <Box className={[classes.appointmentTypeBox, classes.colorBlue].join(' ')}>Sell Vehicle</Box>
            <Box className={classes.appointedAtBox}>
                {DateFormatter.stringDbDate2LongStringDate(selectedAppointment.appointedAt)}
                <br/>
                {DateFormatter.stringDbDate2StringTime(selectedAppointment.appointedAt)}  {props.account.location.timezone_name}
            </Box>
        </Box>
    );
    if (props.account.location.timezone) {
        DateFormatter.timezone = props.account.location.timezone;
    }
    let body = null;
    if (formState.currentPage === 'details') {
        const appointmentAddress = location ? (
            <Box>
                <Box className={classes.appointmentAddressTitleBox}>Appointment Address</Box>
                <Box className={classes.appointedAddressBox}>{location.locationName}</Box>
                <Box className={classes.appointedAddressBox}>{location.locationAddress.street}</Box>
                <Box className={classes.appointedAddressBox}>
                    {location.locationAddress.city + ', '+location.locationAddress.state + ' ' + location.locationAddress.zip}
                </Box>
            </Box>
        ) : null;
        const addressString = location ?
            encodeURI(location.locationAddress.city+' '+location.locationAddress.state+' '+location.locationAddress.zip)
            : '';
        body = (
            <React.Fragment>
                <h3 className={classes.title}>Appointment Details</h3>
                {appointmentDetails}
                {appointmentAddress}
                <Box>
                    <iframe className={classes.map}
                        width="100%"
                        height="300"
                        loading="lazy"
                        src={"https://www.google.com/maps/embed/v1/place?key=AIzaSyD4niu0C67mHSb6pRkwKCVq8VgtW-MICek&zoom=14&q="+addressString}>
                    </iframe>
                </Box>
                {canUserChangeAppointment(props.selectedVehicle, selectedAppointment) && <Box className={classes.bottomControlBox}>
                    <Button className={classes.button} variant="contained" color="primary" component="span" size="medium"
                            disabled={props.loading}
                            onClick={() => {
                                setFormState({
                                    ...formState,
                                    currentPage: 'form'
                                });
                            }}>Change Appointment</Button>
                </Box>}
            </React.Fragment>
        );
    } else if (formState.currentPage === 'form') {
        body = (
            <React.Fragment>
                <h3 className={classes.title}>Change Appointment</h3>
                {appointmentDetails}
                <Box className={classes.formElement} style={{marginTop:'30px'}}>
                    <Box className={classes.label}>What would you like to do?</Box>
                    <Select
                        key={actionField.key}
                        labelId="{actionField.key}-label"
                        id={actionField.key}
                        value={actionField.value}
                        displayEmpty
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, actionField.key, true)}
                        error={!actionField.valid && actionField.touched}
                        margin="dense"
                        variant="outlined"
                        className={classes.input}
                    >
                        <MenuItem value="" className={classes.input}>
                            <em>--Select--</em>
                        </MenuItem>
                        {actionField.values.map((item, i) => (
                            <MenuItem key={actionField.key + i} value={item.key}
                                      className={classes.input}>{item.value}</MenuItem>
                        ))}

                    </Select>
                </Box>
                <Box className={classes.bottomControlBox}>
                    <Button className={classes.button} variant="outlined" color="primary" component="span" size="medium"
                            disabled={props.loading}
                            onClick={() => {
                                history.replace("/dashboard")
                            }}>Cancel</Button>
                    <Button className={classes.button} variant="contained" color="primary" component="span" size="medium"
                            onClick={handleSubmit} disabled={props.loading || !formState.valid}>
                        {props.loading &&
                        <CircularProgress size={30} className={classes.buttonProgress} color="secondary"/>}Submit</Button>
                </Box>
            </React.Fragment>
        );
    } else if (formState.currentPage === 'submitted') {
        body = (
            <React.Fragment>
                <h3 className={classes.title}>Request Received</h3>
                <Box className={classes.appointmentDetailText}>
                    Your request to change the appointment has been received and your account representative has been notified!
                </Box>
                <Box className={classes.bottomControlBox}>
                    <Button className={classes.button} variant="contained" color="primary" component="span" size="medium"
                            disabled={props.loading}
                            onClick={() => {
                                history.replace("/dashboard")
                            }}>Go To Dashboard</Button>
                </Box>
            </React.Fragment>
        );
    }

    return (
        <Box className={[classes.box, classes.width94p].join(' ')}>
            {body}
        </Box>
    );
};

const mapStateToProps = state => {
    return {
        loading: state.app.loading,
        selectedVehicle: state.app.selectedVehicle,
        account: state.account
    };
};

export default connect(mapStateToProps)(AppointmentDetails);